"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HouseBase = void 0;
const chain_base_1 = require("../../chain-base");
class HouseBase extends chain_base_1.ChainBase {
    /**
     * Determine if the passed `uri` is valid
     * @param uri The URI
     */
    isValidURI(uri) {
        try {
            new URL(uri);
            return true;
        }
        catch {
            return false;
        }
    }
}
exports.HouseBase = HouseBase;
